<template>
    <v-lazy>
        <div class="section fade-in grey-card">
            <v-container class="px-10" fluid>
                <v-row cols="12" justify="center">
                    <v-col cols="12" class="text-center">
                        <h2 class="section__header-title">Calendar-based Strategies
                        </h2>
                        <h2 class="text-subtitle-1">Build collection workflows from 1-180 days</h2>
                    </v-col>
                </v-row>
                <v-row justify="center" class="px-25">
                    <v-col cols="12" md="3">
                        <v-card class="mb-8 fill-height">
                            <v-card-title>Custom Strategies</v-card-title>
                            <v-card-text>Setup Engagement Strategies for your customers as they transition through your arrears process.</v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card class="mb-8 fill-height">
                            <v-card-title>Compliance made easy</v-card-title>
                            <v-card-text>Built in compliance with Debt Collection guidelines.</v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card class="mb-8 fill-height">
                            <v-card-title>Rule Systems</v-card-title>
                            <v-card-text>Rule-based system allows for dynamic exclusion of communications at any time, based on common attributes like post code, state, debt value, etc.</v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-img
                    src="../assets/img/calendar.png"
                    class="mx-auto rounded-xl"
                    max-width="74%"
                    contain/>
                </v-row>
            </v-container>
        </div>
    </v-lazy>
</template>
<script>
export default {
    name: 'CollectionsEngagement',
//     data: () => ({
//     numWeeks: 4,
//     numDays: 7,
//     calendarItems: [
//       { dayIdx: 3, title: "Custom Strategies", content: 'Setup Engagement Strategies for your customers as they transition through your arrears process.'},
//       { dayIdx: 13, title: "Custom Strategies", content: 'Setup Engagement Strategies for your customers as they transition through your arrears process.'},
//       { dayIdx: 23, title: "Custom Strategies", content: 'Setup Engagement Strategies for your customers as they transition through your arrears process.'},
//     ],
//   }),
}
</script>

<style lang="scss">

</style>